module.exports = __webpack_public_path__ + "img/9-15.4d8e1154.jpg";